'use strict';

function CompanyAccountCtrl($scope, $stateParams) {
	$scope.stateParams = $stateParams;
}

angular.module('dokiv')
  .controller('CompanyAccountCtrl', [
  '$scope',
  '$stateParams',
  CompanyAccountCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyAccountCtrl.js
// module id = 307
// module chunks = 0